import React, { Component } from "react";
import { Col, Row, Form, FormGroup, Label, Input, Jumbotron, ButtonGroup, Button } from "reactstrap";
import { ListGroup, ListGroupItem, FormFeedback } from "reactstrap";
import FontAwesome from "react-fontawesome";
import update from "immutability-helper";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

import ConfirmationModal from "./modals/ConfirmationModal";
import ProgressModal from "./modals/ProgressModal";
import ErrorModal from "./modals/ErrorModal";

import "./AgendaForm.css";

const minWidth = 400;
const minHeight = 400;
const maxSize = 6000000;

const defaultState = {
  dragOver: false,
  file: null,
  evenement: {
    intitule: { value: "", valid: null },
    description: { value: "", valid: null },
    dates: { value: "", valid: null },
    age_deb: { value: "", valid: null },
    age_fin: { value: "", valid: null },
    structure: { value: "", valid: null },
    theme: { value: "", valid: null },
    lieu: { value: "", valid: null },
    gratuit: { value: "", valid: null },
    tarifs: { value: "", valid: null },
    infos: { value: "", valid: null },
    key: { value: "", valid: null },
    liens: { value: [], valid: null },
    email: { value: "", valid: null },
    file: { valid: "" },
  },
};

function GotLinks(props) {
  return (
    <div>
      liste des adresses web attachées :<br />
      <br />
      <ListGroup>
        {props.liens.map((lien, i) => {
          return (
            <ListGroupItem key={i} className="clearfix" style={{ lineHeight: "40px" }}>
              <a href={lien} target="_blank" rel="noopener noreferrer">
                {lien}
              </a>
              <Button color="danger" className="float-right" onClick={() => props.removeLink(i)}>
                <FontAwesome name="trash" /> Retirer
              </Button>
            </ListGroupItem>
          );
        })}
      </ListGroup>
      <br />
    </div>
  );
}

function formatBytes(a, b) {
  if (0 === a) return "0 Bytes";
  var c = 1024,
    d = b || 2,
    e = ["Octets", "KO", "MO", "GO", "TO", "PO", "EO", "ZO", "YO"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}

let captchaInstance = null;

class AgendaForm extends Component {
  emptyState() {
    this.setState(defaultState);
    if (captchaInstance !== null) captchaInstance.reset();
  }

  constructor(props) {
    super(props);

    this.state = defaultState;

    this.onGratuitRadioBtnClick = this.onGratuitRadioBtnClick.bind(this);
    this.openFile = this.openFile.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.emptyState = this.emptyState.bind(this);
    this.addLink = this.addLink.bind(this);
    this.removeLink = this.removeLink.bind(this);
    this.isCaptchaOK = this.isCaptchaOK.bind(this);
    this.handleError = this.handleError.bind(this);
    this.submit = this.submit.bind(this);
    this.validateRequiredField = this.validateRequiredField.bind(this);
    this.changedState = this.changedState.bind(this);
    this.sendEvent = this.sendEvent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  handleKeyUp(event) {
    if (event.keyCode === 13) {
      this.addLink();
    }
  }

  openFile(event) {
    document.getElementById("file").click();
  }

  deleteFile(event) {
    this.setState(
      update(this.state, {
        file: { $set: null },
      })
    );
  }

  buttonClassName(radioNumber) {
    if (this.state.evenement.gratuit.valid === false) return "danger";
    if (this.state.evenement.gratuit.value === radioNumber) return "primary";

    return "";
  }

  addLink() {
    var urlInput = document.getElementById("lien");
    const regexURL =
      /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;

    if (urlInput.value.match(regexURL) == null) {
      this.errorModal.show("L'adresse URL que vous fournissez doit obligatoirement commencer par http:// ou https://");
      return;
    }

    var newState = update(this.state, {
      evenement: {
        liens: {
          value: { $push: [urlInput.value] },
        },
      },
    });

    this.setState(newState);
    urlInput.value = "";
  }

  removeLink(which) {
    var newLiens = this.state.evenement.liens.value;

    newLiens.splice(which, 1);

    this.setState(
      update(this.state, {
        evenement: {
          liens: {
            value: { $set: newLiens },
          },
        },
      })
    );
  }

  isCaptchaOK(key) {
    if (key == null) key = "";

    var newState = update(this.state, {
      evenement: {
        key: {
          value: { $set: key },
        },
      },
    });

    this.setState(newState);

    this.handleError("key", this.state.evenement.key.value);
  }

  onGratuitRadioBtnClick(which) {
    var tarifs = this.state.evenement.tarifs.value;

    if (which === 1) {
      tarifs = "Gratuit";
    } else {
      if (tarifs === "Gratuit") tarifs = "";
    }
    var newState = update(this.state, {
      evenement: {
        gratuit: {
          value: { $set: which },
          valid: { $set: true },
        },
        tarifs: {
          value: { $set: tarifs },
          valid: { $set: tarifs.length > 1 ? true : false },
        },
      },
    });

    this.setState(newState);
  }

  validateRequiredField(fieldName, fieldValue) {
    var valid = "";

    if (fieldValue === "") valid = false;
    else valid = true;

    return valid;
  }

  handleChange(event) {
    var newState = { evenement: {} };
    var fieldName = event.target.name;
    var fieldValue = event.target.value;

    newState.evenement = Object.assign({}, newState.evenement, this.handleError(fieldName, fieldValue));

    if (fieldName === "file") {
      if (typeof FileReader !== "undefined") {
        var fileInput = document.getElementById("file");
        var file = fileInput.files && fileInput.files[0];

        if (file) {
          var img = new Image();
          var tmp = null;
          img.src = window.URL.createObjectURL(file);

          img.onerror = (e) => {
            this.errorModal.show("Votre image n'est pas reconnue");
          };

          img.onload = (e) => {
            var width = img.naturalWidth,
              height = img.naturalHeight;

            window.URL.revokeObjectURL(img.src);

            var size = file.size;

            var str = "";

            if (size > maxSize) str += "- La taille maximum du fichier ne doit pas exceder 6MO\n";
            if (width < minWidth) str += "- la largeur doit être supérieure ou égale à " + minWidth + " pixels\n";
            if (height < minHeight) str += "- la hauteur doit être supérieure ou égale à " + minHeight + " pixels\n";

            if (str !== "") {
              this.errorModal.show("Votre image ne convient pas : \n" + str);
            } else {
              tmp = file;
            }

            this.setState(
              update(this.state, {
                file: { $set: tmp },
              })
            );
          };
        }
      }
    } else {
      this.setState(update(this.state, newState));
    }
  }

  changedState(fieldName, fieldValue, validValue) {
    var changedState = { [fieldName]: { valid: { $set: validValue } } };
    if (fieldValue !== null) changedState[fieldName].value = { $set: fieldValue };

    return changedState;
  }

  handleError(fieldName, fieldValue) {
    var valid = "";
    var textFieldRequiredList = ["intitule", "description", "dates", "structure", "lieu", "tarifs", "gratuit", "key"];

    //var textFieldRequiredList = [ ];

    if (textFieldRequiredList.indexOf(fieldName) !== -1) {
      valid = this.validateRequiredField(fieldName, fieldValue);
    }

    if (fieldName === "theme") {
      if (fieldValue === "-1") valid = false;
      else valid = true;
    }

    if (fieldName === "email") {
      var pattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!pattern.test(fieldValue)) valid = false;
      else valid = true;
    }

    if (fieldName === "infos") {
      if (fieldValue === "") valid = false;
      else valid = true;
    }

    if (fieldName === "liens") {
      if (fieldValue.length === 0) valid = false;
      else valid = true;
    }

    if (fieldName === "file") {
      if (this.state.file === null) valid = false;
      else valid = true;
    }

    return this.changedState(fieldName, fieldValue, valid);
  }

  submit(event) {
    event.preventDefault();
    var newState = { evenement: {} };
    var e = this.state.evenement;
    var fields = [
      "intitule",
      "description",
      "dates",
      "structure",
      "lieu",
      "tarifs",
      "gratuit",
      "theme",
      "infos",
      "liens",
      "file",
      "key",
      "email",
    ];

    for (let field of fields) {
      var changedState = this.handleError(field, e[field].value);
      newState.evenement = Object.assign({}, newState.evenement, changedState);
    }

    var state = update(this.state, newState);

    this.setState(state, function (a, b, c) {
      var e = this.state.evenement;

      var validFields = [
        "intitule",
        "description",
        "dates",
        "structure",
        "theme",
        "lieu",
        "gratuit",
        "tarifs",
        "key",
        "email",
      ];

      var warningFields = ["infos", "liens", "file"];

      var valid = true;
      var warning = true;

      for (let field of validFields) {
        if (e[field].valid === false) valid = false;
      }

      for (let field of warningFields) {
        if (e[field].valid === false) warning = false;
      }

      var text = <p>Etes vous sur de vouloir valider ce formulaire ?</p>;
      var titre = "Sûr ?";

      if (!valid) {
        titre = "Attention !";
        text = <p>Tous les champs obligatoires en rouge doivent être remplis !</p>;
      } else {
        if (!warning) {
          text = (
            <div>
              Vous pouvez encore ajouter les informations suivantes :
              <ul>
                {!e.infos.valid && <li>Information complémentaire</li>}
                {!e.liens.valid && <li>Lien</li>}
                {!e.file.valid && <li>Illustration</li>}
              </ul>
            </div>
          );
        }
      }

      this.confirmationModal.changeContent(titre, text, !valid, !warning, this.sendEvent);
    });
  }

  sendEvent(moo) {
    if (moo) {
      var data = new FormData();
      var config = {};
      var fileInputElement = document.getElementById("file");

      var form = {
        intitule: this.state.evenement.intitule.value,
        description: this.state.evenement.description.value,
        dates: this.state.evenement.dates.value,
        age_deb: this.state.evenement.age_deb.value,
        age_fin: this.state.evenement.age_fin.value,
        structure: this.state.evenement.structure.value,
        theme: this.state.evenement.theme.value,
        lieu: this.state.evenement.lieu.value,
        gratuit: this.state.evenement.gratuit.value,
        tarifs: this.state.evenement.tarifs.value,
        infos: this.state.evenement.infos.value,
        key: this.state.evenement.key.value,
        liens: this.state.evenement.liens.value,
        email: this.state.evenement.email.value,
      };

      data.append("form", JSON.stringify(form));

      this.progressModal.show({
        onClose: () => {
          document.getElementById("file").value = "";
          this.emptyState();
        },
      });

      if (this.state.file !== null) {
        config.headers = { "content-type": "multipart/form-data" };
        data.append("file", fileInputElement.files[0]);
      }

      config.onUploadProgress = (progressEvent) => {
        var percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.progressModal.setProgress(percentage);
      };

      axios
        .post("/agenda/proposer/proposer.json", data, config)
        .then((response) => {})
        .catch((error) => {});
    }
  }

  validity = (validity) => {
    if (validity !== null) return !validity;
    return null;
  };

  render() {
    var { evenement } = this.state;
    var { file } = this.state;

    return (
      <div className="container">
        <h1>Proposez votre événement à l’agenda de metz.fr</h1>
        <Jumbotron id="box">
          <p className="lead">
            Avant de nous proposer votre événement, vérifiez qu'il ne se trouve pas déjà dans{" "}
            <a href="http://metz.fr/agenda/">metz.fr/agenda</a>.
            <br />
            Les champs marqués d'une * sont à remplir obligatoirement.
          </p>
          <hr className="my-2" />
          <p>
            <a href="#footer">Comment ça marche ?</a>
          </p>
        </Jumbotron>
        <Form id="eventForm">
          <FormGroup row>
            <Label for="intitule" sm={2}>
              Titre <sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="text"
                valid={evenement.intitule.valid}
                invalid={this.validity(evenement.intitule.valid)}
                name="intitule"
                id="intitule"
                value={evenement.intitule.value}
                maxLength="60"
                onChange={this.handleChange}
                placeholder="Titre de l'événement (60 caractères maximum)"
              />
              {evenement.intitule.valid === false && <FormFeedback>Titre manquant</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="description" sm={2}>
              Description<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="textarea"
                valid={evenement.description.valid}
                invalid={this.validity(evenement.description.valid)}
                id="description"
                name="description"
                value={evenement.description.value}
                onChange={this.handleChange}
                rows="8"
                placeholder="Décrivez votre événement en quelques lignes"
              />
              {evenement.description.valid === false && <FormFeedback>Une description est nécessaire</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="dates" sm={2}>
              Dates et horaires<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="textarea"
                valid={evenement.dates.valid}
                invalid={this.validity(evenement.dates.valid)}
                id="dates"
                name="dates"
                value={evenement.dates.value}
                onChange={this.handleChange}
                maxLength="150"
                placeholder="150 caractères maximum, soyez concis !"
              />
              {evenement.dates.valid === false && (
                <FormFeedback>Veuillez préciser les dates de votre événement</FormFeedback>
              )}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="structure" sm={2}>
              Organisateur<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="text"
                valid={evenement.structure.valid}
                invalid={this.validity(evenement.structure.valid)}
                name="structure"
                id="structure"
                value={evenement.structure.value}
                onChange={this.handleChange}
                placeholder="Votre association, entreprise, établissement…"
              />
              {evenement.structure.valid === false && (
                <FormFeedback>Si vous n’êtes pas une organisation, association, précisez-le</FormFeedback>
              )}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="theme" sm={2}>
              Catégorie<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="select"
                id="theme"
                name="theme"
                value={evenement.theme.value}
                invalid={this.validity(evenement.theme.valid)}
                onChange={this.handleChange}>
                <option value="-1">Choisissez</option>
                <option value="3">Animation</option>
                <option value="88">Atelier / Stage</option>
                <option value="20">Concert</option>
                <option value="26">Conférence</option>
                <option value="105">Événement</option>
                <option value="36">Exposition</option>
                <option value="100">Marché</option>
                <option value="114">Portes ouvertes</option>
                <option value="16">Projection</option>
                <option value="90">Salon</option>
                <option value="78">Spectacle</option>
                <option value="80">Sport</option>
                <option value="86">Théâtre</option>
                <option value="117">Vide-grenier / brocante / puces</option>
                <option value="87">Visite libre</option>
              </Input>
              {evenement.theme.valid === false && <FormFeedback>Choisissez dans la liste !</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="structure" sm={2}>
              Lieu<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="text"
                valid={evenement.lieu.valid}
                invalid={this.validity(evenement.lieu.valid)}
                name="lieu"
                id="lieu"
                value={evenement.lieu.value}
                onChange={this.handleChange}
                placeholder="Lieu de l'événement"
              />
              {evenement.lieu.valid === false && <FormFeedback>Lieu manquant !</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>
              Gratuité<sup>*</sup>
            </Label>
            <Col sm={10}>
              <ButtonGroup>
                <Button
                  outline
                  color={this.buttonClassName(1)}
                  onClick={() => this.onGratuitRadioBtnClick(1)}
                  active={evenement.gratuit.value === 1}>
                  Oui
                </Button>
                <Button
                  outline
                  color={this.buttonClassName(0)}
                  onClick={() => this.onGratuitRadioBtnClick(0)}
                  active={evenement.gratuit.value === 0}>
                  Non
                </Button>
              </ButtonGroup>
              <Input type="hidden" value={evenement.gratuit.value} valid={evenement.gratuit.valid} />
              {evenement.gratuit.valid === false && <FormFeedback>Tarif manquant !</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="tarifs" sm={2}>
              Tarifs<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="textarea"
                disabled={evenement.gratuit.value === 1}
                valid={evenement.tarifs.valid}
                invalid={this.validity(evenement.tarifs.valid)}
                name="tarifs"
                id="tarifs"
                value={evenement.tarifs.value}
                onChange={this.handleChange}
                placeholder="Détails des tarifs d'entrée"
              />
              {evenement.tarifs.valid === false && (
                <FormFeedback>Votre événement n’est pas gratuit, vous devez ajouter vos tarifs</FormFeedback>
              )}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="infos" sm={2}>
              Infos
            </Label>
            <Col sm={10}>
              <Input
                type="textarea"
                name="infos"
                id="infos"
                value={evenement.infos.value}
                onChange={this.handleChange}
                placeholder="Informations complémentaires"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="" sm={2}>
              Liens
            </Label>
            <Col sm={10}>
              {evenement.liens.value.length === 0 && (
                <span>
                  Pas de lien attaché, utiliser le champ de texte ci-dessous pour en ajouter.
                  <br />
                </span>
              )}
              {evenement.liens.value.length > 0 && (
                <GotLinks liens={evenement.liens.value} removeLink={this.removeLink} />
              )}
              <Row>
                <Col sm={6}>
                  <Input type="text" name="lien" id="lien" placeholder="Ajouter un lien" onKeyUp={this.handleKeyUp} />
                </Col>
                <Col sm={6}>
                  <Button color="primary" onClick={this.addLink}>
                    Enregistrer
                  </Button>
                </Col>
              </Row>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="" sm={2}>
              Illustration
            </Label>
            <Col sm={10}>
              <Input
                type="file"
                name="file"
                id="file"
                onChange={this.handleChange}
                accept="image/jpeg,image/png,image/gif"
                hidden
              />
              <Button color="primary" onClick={this.openFile}>
                <FontAwesome name="upload" />{" "}
                {file === null && <span>Joindre une image (jpg ou png) pour l'illustration</span>}
                {file !== null && (
                  <span>
                    {file.name} ({formatBytes(file.size, 2)})
                  </span>
                )}
              </Button>{" "}
              {file !== null && (
                <Button color="danger" onClick={this.deleteFile}>
                  <FontAwesome name="trash" /> Retirer le fichier
                </Button>
              )}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="intitule" sm={2}>
              Email<sup>*</sup>
            </Label>
            <Col sm={10}>
              <Input
                type="text"
                valid={evenement.email.valid}
                invalid={this.validity(evenement.email.valid)}
                name="email"
                id="email"
                value={evenement.email.value}
                onChange={this.handleChange}
                placeholder="Votre email"
              />
              {evenement.email.valid === false && <FormFeedback>Email manquant invalide !</FormFeedback>}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="infos" sm={2}>
              Vérification<sup>*</sup>
            </Label>
            <Col sm={10}>
              <ReCAPTCHA
                ref={(e) => (captchaInstance = e)}
                onChange={this.isCaptchaOK}
                sitekey="6LdPjAwTAAAAAKJlyaceYboOlDfebAH9t1FFz2sn"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={2}></Col>
            <Col sm={10}>
              <Button color="primary" onClick={this.submit}>
                Valider le formulaire
              </Button>
            </Col>
          </FormGroup>
        </Form>
        <ErrorModal
          ref={(instance) => {
            this.errorModal = instance;
          }}
        />
        <ConfirmationModal
          ref={(instance) => {
            this.confirmationModal = instance;
          }}
        />
        <ProgressModal
          ref={(instance) => {
            this.progressModal = instance;
          }}
        />
      </div>
    );
  }
}

export default AgendaForm;



// WEBPACK FOOTER //
// ./src/AgendaForm.jsx